import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

export const workshopsAxios = buildMakeUseAxios(`${import.meta.env.VITE_WORKSHOP_SERVICE_URL}/workshops`);
export const workshopsAxiosInstance = buildAxiosInstance(`${import.meta.env.VITE_WORKSHOP_SERVICE_URL}/workshops`);
